import React from 'react'
import { NavLink } from 'react-router-dom'
const Portfolio = () => {
    return (
        <>
            <section className="portfolio">
                <div className="container py-3">
                    <h5>These are the Portfolios that I have created before today.</h5>
                    <marquee scrolldelay="200">" My portfolios showcase my creativity, skills, and achievements, reflecting my passion for excellence and continuous growth."</marquee>
                    <hr />
                    <div className="row">
                        <div className="col-lg-3 col-md-6 my-2 d-flex align-items-stretch">
                            <div className="card">
                                <img src="img/portfolio/1.webp" className="img-fluid img-thumbnail" alt="IMG-1" />
                                <div className="card-body">
                                    <h5>Rana Rizwan</h5>
                                    <p className='text-justify'>Rana Rizwan is my project focusing on Data Intelligence and Big Data Analytics to unlock valuable insights and enhance decision-making.</p>
                                    <NavLink to="https://ranarizwan.netlify.app/" target='_rizwan' className="btn-button">Read More</NavLink>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 my-2 d-flex align-items-stretch">
                            <div className="card">
                                <img src="img/portfolio/2.webp" className="img-fluid img-thumbnail" alt="IMG-2" />
                                <div className="card-body">
                                    <h5>Rizwan 7351</h5>
                                    <p>I have developed a project called Rizwan 7351, centered around cutting-edge tech solutions and innovation.</p>
                                    <NavLink to="https://rizwan7351.netlify.app/" target='_rizwan' className="btn-button">Read More</NavLink>
                                </div>
                            </div>
                        </div>
                        <div className="col box text-white d-flex align-items-center my-2">
                            <h5>Due to office work, I am not able to update my portfolio nowadays. As soon as I get my time, I will update my portfolio and add some websites on it.</h5>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Portfolio